<header class="hearing-page-header" data-testid="hearing-page-header" [attr.aria-label]="title()">
  <div class="hearing-page-header__identity">
    <h1 class="hearing-page-header__title" tabindex="-1" data-testid="hearing-page-title">{{ title() }}</h1>
    <span
      *ngIf="status() as statusText"
      class="hearing-page-header__status"
      [attr.data-tone]="statusTone()"
      data-testid="hearing-page-status"
    >{{ statusText }}</span>
    <span *ngIf="currentStepLabel() as step" class="hearing-page-header__step" data-testid="hearing-page-current-step">
      <span class="hearing-page-header__label">Current step</span>
      <strong>{{ step }}</strong>
    </span>
    <span *ngIf="decisionDetail() as decision" class="hearing-page-header__decision" data-testid="hearing-page-decision">
      Decision recorded: {{ decision }}<ng-container *ngIf="decisionRecordedUtc() as recorded"> · {{ formatDate(recorded) }}</ng-container>
    </span>
  </div>

  <a
    *ngIf="launchHearingId() as hearingId"
    class="hearing-page-header__launch"
    routerLink="/workflows/start"
    [queryParams]="{ hearingId: hearingId }"
    data-testid="start-hearing-workflow"
  >Start workflow</a>
  <button
    type="button"
    class="hearing-page-header__toggle"
    data-testid="hearing-details-toggle"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="detailsId"
    (click)="toggle()"
  >
    <span>{{ hearingText.detailsHistory() }}</span>
    <span class="hearing-page-header__chevron" aria-hidden="true"></span>
  </button>
</header>

<section
  *ngIf="expanded()"
  class="hearing-page-details"
  [id]="detailsId"
  data-testid="hearing-details"
  [attr.aria-label]="hearingText.detailsHistory()"
>
  <p *ngIf="isLoading() && !record()" class="hearing-page-details__state" data-testid="hearing-details-loading">Loading hearing details…</p>

  <div class="hearing-page-details__facts">
    <section class="hearing-page-details__panel" aria-label="Identity essentials" data-testid="hearing-details-identity">
      <h2>Identity essentials</h2>
      <ng-container *ngIf="demographics() as d; else identityUnavailable">
        <p class="hearing-page-details__subject">
          <strong>{{ display(subjectName()) }}</strong>
          <small>{{ display(d.incarceratedPersonIdentifier || d.cdcNumber) }}</small>
        </p>
        <dl class="hearing-page-details__list">
          <div><dt>Age / DOB</dt><dd>{{ ageDobLabel() }}</dd></div>
          <div><dt>Gender</dt><dd>{{ display(d.gender) }}</dd></div>
          <div><dt>Race / Ethnicity</dt><dd>{{ display(d.raceEthnicity) }}</dd></div>
          <div><dt>Languages</dt><dd>{{ display(d.languages) }}</dd></div>
          <div><dt>Facility</dt><dd>{{ display(custodyTerm()?.facilityLabel || d.facilityLabel || d.facilityCode) }}</dd></div>
          <div><dt>Security level</dt><dd>{{ display(custodyTerm()?.securityLevel || d.custodyLevel) }}</dd></div>
          <div><dt>Admit</dt><dd>{{ formatDate(d.admitDate) }}</dd></div>
          <div><dt>Eligibility</dt><dd>{{ formatDate(d.eligibilityDate) }}</dd></div>
          <div><dt>Release</dt><dd>{{ formatDate(d.projectedReleaseDate) }}</dd></div>
        </dl>
      </ng-container>
      <ng-template #identityUnavailable>
        <p class="hearing-page-details__state">Identity details unavailable.</p>
      </ng-template>
    </section>

    <section class="hearing-page-details__panel" aria-label="This hearing" data-testid="hearing-details-hearing">
      <h2>This hearing</h2>
      <ng-container *ngIf="proceeding() as p; else hearingUnavailable">
        <p class="hearing-page-details__subject">
          <strong>{{ display(p.title) }}</strong>
          <small>{{ p.scheduledStartUtc ? formatDateTime(p.scheduledStartUtc) : "Not scheduled" }}</small>
        </p>
        <dl class="hearing-page-details__list">
          <div><dt>Format</dt><dd>{{ display(p.format) }}</dd></div>
          <div><dt>Requirements</dt><dd>{{ requirementsLabel() }}</dd></div>
          <div class="hearing-page-details__wide"><dt>Location</dt><dd>{{ locationLabel() }}</dd></div>
          <div class="hearing-page-details__wide"><dt>Panel</dt><dd>{{ panelLabel() }}</dd></div>
        </dl>
        <ul *ngIf="requirements().length > 0" class="hearing-page-details__requirements">
          <li *ngFor="let requirement of requirements()" [class.is-complete]="isRequirementComplete(requirement.statusCode)">
            <span aria-hidden="true"></span>{{ requirement.label }}
          </li>
        </ul>
      </ng-container>
      <ng-template #hearingUnavailable>
        <p class="hearing-page-details__state">Hearing details unavailable.</p>
      </ng-template>
    </section>
  </div>

  <section class="hearing-page-details__panel hearing-page-details__history" aria-label="Workflow history" data-testid="hearing-details-workflow">
    <phms-workflow-ledger [compact]="true" [ledger]="ledger()" [state]="ledgerState()"></phms-workflow-ledger>
  </section>

  <section class="hearing-page-details__panel hearing-page-details__activity" aria-label="Hearing activity" data-testid="hearing-details-activity">
    <phms-audit-activity-log
      perspectiveCode="hearing"
      [embedded]="true"
      [subjectId]="scheduledProceedingId()"
      title="Hearing Activity"
      emptyMessage="No hearing activity has been recorded yet."
      [take]="50"
    ></phms-audit-activity-log>
  </section>
</section>
